import React, { PropsWithChildren, forwardRef } from 'react';
import { close } from 'static/icons/resizable';
import { createPortal } from 'react-dom';
import { SimpleInterpolation } from 'styled-components';
import * as S from './ModalWindow.styles';

type ModalWindowProps = PropsWithChildren<{
  contentStyles?: SimpleInterpolation;
  hideWindow: (e: React.MouseEvent<HTMLDivElement>) => void;
  'data-testid'?: string;
}>;

export const ModalWindow = forwardRef<HTMLDivElement, ModalWindowProps>(
  ({ hideWindow, contentStyles, children, 'data-testid': dataTestId }, ref) => {
    return createPortal(
      <S.ModalStyled ref={ref} onClick={(e) => e.stopPropagation()}>
        <S.ModalContentStyled
          customStyles={contentStyles}
          data-testid={dataTestId}
        >
          <S.CloseButtonStyled data-testid='ModalWindow-CloseButton' onClick={hideWindow}>
            <img src={close} alt='Close button' />
          </S.CloseButtonStyled>
          {children}
        </S.ModalContentStyled>
      </S.ModalStyled>,
      document.body,
    );
  },
);
